export default "__VITE_ASSET__ClpUCew$__"